import {
  aCreateCustomInsight,
  mockCreateCustomInsightOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockCreateCustomInsightOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          createCustomInsight: aCreateCustomInsight(),
        },
      });
    }
  ),
];
